// app/javascript/controllers/rsvp_invitation_print_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "image", "legacyInvite"]

    print(event) {
        event.preventDefault()

        if (this.hasImageTarget) {
            this.printImage()
            return
        }

        if (this.hasLegacyInviteTarget) {
            this.printLegacyInvite()
            return
        }

        console.warn("[rsvp-invitation-print] No printable invitation target found.")
    }

    printImage() {
        const imageUrl = this.imageTarget.currentSrc || this.imageTarget.src
        if (!imageUrl) return

        const alt = this.imageTarget.alt || "Invitation"
        const printWindow = window.open("", "_blank")
        if (!printWindow) return

        printWindow.document.write(`
      <html>
        <head>
          <title>Print Invitation</title>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              background: #ffffff;
            }

            body {
              display: flex;
              align-items: flex-start;
              justify-content: center;
            }

            img {
              max-width: 100%;
              height: auto;
              display: block;
            }

            @media print {
              @page {
                margin: 0.25in;
              }

              html, body {
                width: 100%;
              }

              img {
                max-width: 100%;
                max-height: 100vh;
              }
            }
          </style>
        </head>
        <body>
          <img src="${this.escapeAttribute(imageUrl)}" alt="${this.escapeAttribute(alt)}" />
        </body>
      </html>
    `)

        printWindow.document.close()

        printWindow.onload = function () {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        }
    }

    printLegacyInvite() {
        const inviteHtml = this.legacyInviteTarget.outerHTML
        const stylesheetLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map((link) => link.outerHTML)
            .join("\n")

        const customStyles = Array.from(document.querySelectorAll("style"))
            .map((style) => style.outerHTML)
            .join("\n")

        const printWindow = window.open("", "_blank")
        if (!printWindow) return

        printWindow.document.write(`
      <html>
        <head>
          <title>Print Invitation</title>
          ${stylesheetLinks}
          ${customStyles}
          <style>
            html, body {
              margin: 0;
              padding: 0;
              background: #ffffff;
            }

            body {
              display: flex;
              justify-content: center;
              align-items: flex-start;
              padding: 20px;
            }

            .legacy-invite-wrapper,
            .legacy-invite-figure {
              margin: 0 !important;
            }

            @media print {
              @page {
                margin: 0.25in;
              }

              body {
                padding: 0;
              }
            }
          </style>
        </head>
        <body>
          ${inviteHtml}
        </body>
      </html>
    `)

        printWindow.document.close()

        printWindow.onload = function () {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        }
    }

    escapeAttribute(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
    }
}